import Vue from "vue";

const statuses = [
    {
        text: 'Ativa',
        value: 'active',
        color: 'success'
    },
    {
        text: 'Inativa',
        value: 'inactive',
        color: 'gray'
    },
    {
        text: 'Cancelada',
        value: 'canceled',
        color: 'error'
    },
]

export const $subscription = {
    statuses: statuses,
    statusLabels: statuses.reduce((acc, status) => {
        acc[status.value] = status.text
        return acc
    }, {}),
}

Vue.prototype.$subscription = $subscription;
